export default __webpack_public_path__ + "static/media/broker-template-3.8cc3d13b.svg";